/*
 * @Author: Hyman Choi
 * @Date: 2021-03-22 11:28:18
 * @LastEditTime: 2021-03-22 11:28:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\utils\utils.js
 */
const utils = {}

/**
 * 停止 loding
 *
 * @export
 * @param {*} vm
 */
utils.stopLoading = vm => {
  setTimeout(() => {
    vm.loading = false
  }, 500)
}

export default utils
